import React from 'react';
import {getLang} from "../../../../common";

const RepeatSms = ({ brandName, lang, translationForReg, onClick }) => {
  return(
    <span className='VerifyCode-Repeat link' onClick={onClick}>
      {getLang(translationForReg, brandName, lang, 'confirmCodeRepeatedRequestLink')}
    </span>
  )
}

export default RepeatSms